<div class="dialog-container">
  <div class="dialog-header">
    <div class="dialog-header--title">
      <h2 class="pb-0" data-translation-key="horse_view_make_an_offer">
        {{ 'horse_view.make_an_offer' | translate }}
      </h2>
      <p
        class="subtitle"
        data-translation-key="horse_view_make_an_offer_subtitle"
        >
        {{ 'horse_view.make_an_offer_subtitle' | translate }}
      </p>
    </div>
    <span mat-dialog-close class="pb-0">
      <img src="../../../../../../../assets/images/close.svg" alt="close" />
    </span>
  </div>
  <!-- <h5 class="offer-value">
  {{ 'horse_view.min_offer_amount' | translate }} 50000$
</h5> -->
<div class="pt-0 mt-2">
  <form
    [formGroup]="offerForm"
    class="d-flex justify-content-between flex-column gap-1"
    >
    <div class="form-field">
      <label class="mb-1" data-translation-key="horse_view_your_offer"
        >{{ 'horse_view.your_offer' | translate }}<span class="required">*</span></label
        >
        <mat-form-field appearance="outline">
          <input
            appNumbersOnly
            type="number"
            min="1"
            matInput
            formControlName="amount"
            [placeholder]="'make_offer_dialog.horse_view_enter_your_offer' | translate"
            data-translation-key="horse_view_enter_your_offer"
            />
            <span class="p-3" matSuffix>{{
              currency?.currency_code | currencySymbol :(localeService.locale$ | async)
            }}</span>
            @if (amount?.invalid && (amount?.dirty || amount?.touched)) {
              <mat-error
                >
                @if (amount?.errors?.['required']) {
                  <span
                    data-translation-key="horse_view_required_field"
                    >{{ 'horse_view.required_field' | translate }}</span
                    >
                }
                @if (amount?.errors?.['min']) {
                  <span
                    data-translation-key="horse_view_min_offer_error"
                    >{{ 'horse_view.min_offer_error' | translate }}</span
                    >
                  }
                </mat-error>
              }
            </mat-form-field>
          </div>
          <div class="form-field">
            <label class="mb-1" data-translation-key="horse_view_your_message">{{ 'horse_view.your_message' | translate }}</label>

            <mat-form-field appearance="outline">
              <textarea
                matInput
                rows="10"
                formControlName="notes"
                [placeholder]="'make_offer_dialog.horse_view_enter_your_message' | translate"
                data-translation-key="horse_view_enter_your_message"
              ></textarea>
            </mat-form-field>
          </div>
        </form>
      </div>
      <div class="dialog-footer">
        <div class="d-flex justify-content-between w-100">
          <button
            class="btn btn-primary w-100"
            [disabled]="offerForm.invalid || isSubmitting"
            (click)="submitOffer()"
            >
            @if (!isSubmitting) {
              <span data-translation-key="horse_view_submit">{{ 'horse_view.submit' | translate }}</span>
            }
            @if (isSubmitting) {
              <span>
                <mat-spinner [diameter]="20"></mat-spinner>
              </span>
            }
          </button>
        </div>
      </div>
    </div>
